export default __webpack_public_path__ + "static/media/Logo.29c9cb63.png";